export default "__VITE_ASSET__DqEOeGhT__"